(ns client-portal.client.components.analytics
  (:require [client-portal.client.anonymous.data :as anon.d]
            [shared.core.components.components :as c]
            [shared.core.components.icon :as icon]
            [shared.core.components.recharts-components :as recharts.c]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(defn- location-detail-line [{:keys [icon-type]} value]
  [:div {:style {:display :flex
                 :align-items :center
                 :gap 8}}
   [c/material-icon {:icon-type icon-type
                     :style {:font-size 16
                             :color (style/alc-color "Icons/primary")}}]
   [:div {:style {:font-family style/roboto-font-family
                  :font-size 12
                  :font-weight style/font-regular-weight
                  :line-height :normal
                  :color (style/alc-color "Text/primary")}}
    value]])

(defn location-header
  "A location's map, name and contact details — the block a product dashboard puts
   above its stats when a location is selected. Fed the location map (`:loading`
   while it loads, as `:locations/by-current-location-id-` returns it); any extra
   `contents` render beneath the details, and the stats go after this component."
  [{:keys [location-details]} & contents]
  (let [loading? (util/loading? location-details)
        {:keys [label latitude longitude street-address city state-code country-code telephone]} location-details
        map-size 95]
    [:div {:style {:display :flex
                   :gap 24}}
     (when (or loading?
               (and (not-empty (str latitude)) (not-empty (str longitude))))
       [:div {:style (cond-> {:width map-size
                              :height map-size
                              :border-radius 5
                              :overflow :hidden
                              :position :relative}
                             (not loading?)
                             (assoc :cursor :pointer))
              :on-click (when-not loading?
                          #(re/dispatch-sync [:router/go-open-new-url
                                              (str "https://maps.google.com/?q=" latitude "," longitude)]))}
        (if loading?
          [c/loader-rectangle {:width map-size :height map-size}]
          ;; Oversized and scaled down: the embed has a minimum usable size, and the
          ;; container crops it to the thumbnail.
          [:div {:style {:width (+ 400 map-size)
                         :height (+ 400 map-size)
                         :position :absolute
                         :top -200
                         :left -200
                         :transform "scale(0.5)"}}
           [c/google-map-iframe {:latitude latitude
                                 :longitude longitude
                                 :zoom 13
                                 :style {:pointer-events :none}}]])])
     (into [:div {:style {:display :flex
                          :flex-direction :column
                          :flex 1
                          :gap 8}}
            (if loading?
              [c/loader-rectangle {:width 380
                                   :height 14
                                   :style {:margin-bottom 8}}]
              [:div {:style {:padding-bottom 4
                             :font-family style/roboto-font-family
                             :font-size 15
                             :font-weight style/font-semi-bold-weight
                             :color (style/alc-color "Text/primary_header")}}
               (anon.d/location-label label)])
            (if loading?
              [c/loader-rectangle {:width 240
                                   :height 14}]
              [:<>
               (when (not-empty street-address)
                 [location-detail-line {:icon-type :location-on}
                  (util/->formatted-address {:street-address-1 street-address
                                             :city city
                                             :state state-code
                                             :country country-code})])
               (when (not-empty telephone)
                 [location-detail-line {:icon-type :call}
                  (util/readable-phone-number telephone)])])]
           contents)]))

(defn header-line-chart
  "The sparkline beside a headline number — green when the period ends higher than it
   started, red when it ends lower."
  [{:keys [data]}]
  (let [down? (> (:y (first data)) (:y (last data)))]
    [recharts.c/line-chart {:data (mapv (fn [{:keys [x y]}]
                                          {:x x
                                           :y (/ y 100)})
                                        data)
                            :x-key :x
                            :y-key :y
                            :color (if down?
                                     (style/alc-color "extended[day]/chart/red")
                                     (style/alc-color "extended[night]/chart/green"))
                            :x-axis-visible? false
                            :y-grid-visible? false
                            :tooltip-visible? false
                            :width 40
                            :height 30}]))

(defn header-with-content
  [{:keys [icon-type title]} & contents]
  [:div {:style {:display :flex
                 :flex-direction :column
                 :flex 1
                 :padding "12px 12px 9px"
                 :gap 12}}
   [:div {:style {:display :flex
                  :align-items :center
                  :gap 8}}
    [icon/material-icon {:icon-type icon-type
                         :style {:color (style/alc-color "Text/primary")
                                 :font-size 18}}]
    [:span {:style {:font-family style/roboto-font-family
                    :font-size 12
                    :line-height "18px"
                    :color (style/alc-color "Text/primary")}}
     title]]
   (into [:div {:style {:display :flex
                        :align-items :center
                        :gap 12}}]
         contents)])